<template>
    <div>
        <div>
            <v-alert type="error"
                     style="padding: 16px"
                     v-if="submitted && missingFields.length > 0">
                <div>
                    Les champs suivants sont obligatoires :
                    <ul v-for="field in missingFields" class="mt-2">
                        <li class="list-required-fields-items">{{ field.name }}</li>
                    </ul>
                </div>
            </v-alert>
        </div>

        <div>
            <v-alert type="error"
                     style="padding: 16px"
                     v-if="submitted && missingFields.length === 0 && !isValidEmail">
                <div>
                    Le format de votre email n'est pas valide
                </div>
            </v-alert>
        </div>

        <div>
            <v-alert type="error"
                     style="padding: 16px"
                     v-if="submittedDraft && checkCopyrightsLengths()">
                <div>
                    Le copyright d'une image ne doit pas dépasser 255 caractères.
                </div>
            </v-alert>
        </div>

        <div class="d-flex justify-content-center gap-20 align-items-center flex-wrap">
            <v-btn class="default-button custom-button-accent" @click="validBeforeSave(true)"
                   :disabled="webFormState === 'SAVING' || preview">
                <v-icon class="mr-2" :color="primaryColor">save</v-icon>
                <span :style="'color:' + primaryColor + '!important'">
                    Enregistrer en brouillon
                </span>
            </v-btn>

            <v-progress-circular class="progressbar ml-2 text-primary" indeterminate size="20"
                                 v-if="webFormState === 'SAVING'" width="2">
            </v-progress-circular>

            <v-btn class="default-button custom-button-primary" :style="'background-color:' + primaryColor + '!important'"
                   :disabled="webFormState === 'SAVING' || preview"
                   @click="validBeforeSave(false)">
                <v-icon class="mr-2">check</v-icon>
                Valider mes informations
            </v-btn>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState, mapGetters} from "vuex"
import * as EmailValidator from "email-validator"
import hash from "object-hash"
import _ from "lodash"

import { fieldsMapping } from "../../../static/webform"

export default {
    name: "CmajFormFooter",
    data() {
        return {
            webFormState: null,
            updated: 0,
            draftInterval: null,
            submittedDraft: false,
        }
    },
    methods: {
        ...mapMutations('web_form', ['setSubmitted', 'setCopyrightDialog', 'setPricePeriodDialog',
            'setOpeningPeriodDialog', 'setIsDirty', 'setDisplayThanks']),
        validBeforeSave(draft = false) {
            if(draft) {
                this.submittedDraft = true
                this.setSubmitted(false)

                if(!this.checkCopyrightsLengths()) {
                    this.save(true)
                }
            } else {
                this.setSubmitted(true)
                this.submittedDraft = false

                let validation = this.isValidEmail && this.missingFields.length === 0

                let hasOpeningPeriods = this.provider.opening_periods.length > 0
                let hasPricePeriods = this.provider.price_periods.length > 0

                if (validation) {
                    if (this.hasField('IMAGE') && this.hasEmptyCopyrights() && !this.hasConfirmedCopyrights) {
                        this.setCopyrightDialog(true)
                    } else if (!hasOpeningPeriods && !this.hasConfirmedOpeningPeriods && this.hasField('OPENING_HOURS')) {
                        this.setOpeningPeriodDialog(true)
                    } else if (!hasPricePeriods && !this.hasConfirmedPricePeriods && this.hasFamilyElement('OfferType')) {
                        this.setPricePeriodDialog(true)
                    } else {
                        this.save(false)
                    }
                }
            }
        },
        checkCopyrightsLengths() {
            return this.provider.medias.filter(media => media.copyright && media.copyright.length > 255).length !== 0
        },
        getFormattedOpeningPeriods() {
            let openingPeriodsCopy = JSON.parse(JSON.stringify(this.provider.opening_periods))

            openingPeriodsCopy = openingPeriodsCopy.map(period => {
                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }

                period.h24 = false
                period.opening_days = period.opening_days.map(day => {
                    day.opening_hours = day.opening_hours.map(hour => _.pick(hour, ['close', 'open']))

                    return  _.pick(day, ['closed', 'day_of_week', 'opening_hours'])
                })

                return _.pick(period, ['description', 'valid_from', 'valid_through', 'external_id', 'h24', 'opening_days'])
            })

            return openingPeriodsCopy
        },
        getFormattedPricePeriods() {
            let pricePeriodsCopy = JSON.parse(JSON.stringify(this.provider.price_periods))

            pricePeriodsCopy = pricePeriodsCopy.map(period => {
                if (period.external_id !== null && period.external_id !== undefined) {
                    period.external_id = period.external_id.toString()
                }

                return _.pick(period, ['prices', 'valid_from', 'valid_through', 'external_id'])
            })

            return pricePeriodsCopy
        },
        save(draft) {
            this.setCopyrightDialog(false)

            let formToken = this.$route.params.pathMatch?.split('/')[1]

            this.fixData()

            let payload = {
                provider: this.provider,
                contact: this.contact,
                token: formToken,
                extra: this.extra,
                openThisSeason: 1,
                draft: draft,
                openForm: this.isOpenForm,
                providerId: this.id,
                origin: this.origin,
                skippedFields: this.getSkippedFields,
                aspect: this.aspect,
            }

            this.webFormState = 'SAVING'

            this.setIsDirty(false)
            this.baseProviderHash = hash(this.provider)

            this.$http.post('webform/answer', payload).then(res => {
                this.setSubmitted(false)

                let token = this.$route.params.token

                if (this.isOpenForm) {
                    token = res.body.data.token

                    this.postSaveOpenForm(draft, token)
                } else if (this.origin === 'USKA') {
                    const code = draft ? 'SAVE_DRAFT' : 'SAVE_FORM'
                    // cas ou on est sur Uska
                    window.parent.postMessage(code, "*");
                } else if (draft) {
                    setTimeout(() => {
                        this.$router.push('/espace-pro/' + token + '/solicitations')
                    }, 4000)
                } else {
                    setTimeout(() => {
                        this.$router.push({path: "/espace-pro/" +token + "/solicitations",
                            query: {displayThanks: 'true', category: this.provider.category.name} })
                    }, 4000)
                }
            })
        },
        postSaveOpenForm(draft, token) {
            if (draft) {
                this.draftInterval = setInterval(() => {
                    this.$http.get("webform/state/" + token).then((res) => {
                        this.webFormState = res.body.data.state.code
                    })
                }, 5000)

                this.$global.$emit("success-request", {
                    body: {
                        message:
                            "Votre réponse a bien été enregistrée en brouillon. Vous devrez revenir plus tard pour la compléter et la valider.",
                    },
                })
            } else {
                this.setDisplayThanks(true)
            }
        },
        fixData() {
            if (this.provider.localisation.commune !== undefined && this.provider.localisation.commune !== null) {
                this.provider.localisation.commune_id = this.provider.localisation.commune.id
            }

            this.provider.capacities = this.capacities.filter(capacity => {
                return capacity.value !== undefined && capacity.value !== ''
            })

            this.provider.price_periods.forEach(period => {
                period.prices.map(price => {
                    if (price.mode === 'UNIQUE') {
                        price.max = price.min
                    } else if (price.mode === 'FROM') {
                        price.max = null
                    }
                })
            })

            if (this.provider.room_renting !== undefined) {
                this.provider.room_renting.rooms.forEach(room => {
                    if (room.area !== null) {
                        room.area = room.area.toString().replace(',', '.')
                    }
                })
            }

            if (this.provider.opening_periods !== undefined) {
                this.provider.opening_periods.forEach(period => {
                    period.opening_days.forEach(day => {
                        if (day.closed === null) {
                            day.closed = day.opening_hours === undefined || day.opening_hours.length === 0
                        }
                    })
                })
            }
        },
        isRequired(code) {
            return this.getRequiredFields.find(field => field.fieldable.code === code)
        },
        getRequiredFieldValue(fieldRef) {
            let value = null
            let obj = this.provider[fieldRef.path]

            // cas obj lists (ex: contents pour recup celui avec la langue 'fr')
            if (obj !== undefined && fieldRef.filter) {
                obj = obj.find(item => _.get(item, fieldRef.filter.path) === fieldRef.filter.value)
            }

            // cas obj simple (ex: name ou localisation.address)
            if (obj !== undefined && !Array.isArray(obj)) {
                value = fieldRef.property ? obj[fieldRef.property] : obj
            }

            // cas spécifique sur les listes (ex: médias ou on doit vérifier tous les copyrights, ou opening_periods
            // où on doit juste avoir au moins une période de renseignée)
            if (obj !== undefined && Array.isArray(obj)) {
                if (fieldRef.property !== null) {
                    let firstNullValue = obj.find(item => item[fieldRef.property] === null)

                    value = (firstNullValue !== undefined && firstNullValue !== null) ? null : true
                } else {
                    value = obj.length === 0 ? null : true
                }
            }

            return value
        },
        hasEmptyCopyrights() {
            return this.provider.medias.filter(media => media.copyright === null || media.copyright === '').length !== 0
        }
    },
    computed: {
        ...mapState('web_form', ['submitted', 'contact', 'acceptCgu', 'provider', 'hasConfirmedCopyrights',
            'hasConfirmedPricePeriods', 'hasConfirmedOpeningPeriods', 'baseOpeningPeriods', 'basePricePeriods',
            'capacities', 'origin', 'isOpenForm', 'id', 'preview', 'extra', 'capacities', 'aspect']),
        ...mapGetters('web_form', ['getRequiredFields', 'getElementsByFamilyCode', 'hasField', 'hasFamilyElement',
            'getElementsByFamilyId', 'getSkippedFields']),
        ...mapState('webFormStyle', ['primaryColor',]),
        isValidEmail() {
            return EmailValidator.validate(this.contact.email)
        },
        missingFields() {
            let missingFields = []

            // utilisé pour trigger ce computed via le watcher du provider
            this.updated
            this.getRequiredFields.forEach(field => {
                let fieldRef = fieldsMapping.find(fieldMapping => {
                    return field.fieldable.code === fieldMapping.code || field.fieldable.name === fieldMapping.code
                })

                // ne sont géré que les attributs pour cette 1ere condition (évite de constituer un ref des éléments)
                if (fieldRef) {
                    let value = this.getRequiredFieldValue(fieldRef)

                    if (value === null || value === '') {
                        missingFields.push(field)
                    }
                } else if(field.fieldable_type === 'App\\Models\\Referential\\FamilyElement' &&
                  field.name !== 'Capacités') {
                    let elements = this.getElementsByFamilyId(field.fieldable_id)

                    if (elements.length === 0 && field.hasElementsInReferential) {
                        missingFields.push(field)
                    }
                } else if(field.fieldable_type === 'App\\Models\\Referential\\FamilyElement' &&
                  field.name === 'Capacités') {
                    if(this.capacities.length > this.provider.capacities.length) {
                        missingFields.push(field)
                    }
                }
            })

            if (this.contact.first_name === null || this.contact.first_name === '') {
                missingFields.push({ name: 'Prénom' })
            }

            if (this.contact.last_name === null || this.contact.last_name === '') {
                missingFields.push({ name: 'Nom' })
            }

            if (this.contact.email === null || this.contact.email === '') {
                    missingFields.push({ name: 'E-mail' })
            }

            if (!this.acceptCgu) {
                missingFields.push({ name: 'Les Conditions d\'utilisation doivent être acceptées.' })
            }

            if(this.checkCopyrightsLengths()) {
                missingFields.push({ name: 'Le copyright d\'une image ne doit pas dépasser 255 caractères.' })
            }

            return missingFields
        }
    },
    watch: {
        provider: {
            handler() {
                this.updated++
            },
            deep: true
        }
    },
    created() {
        this.$global.$on('trigger-save', () => this.validBeforeSave(false))
        this.$global.$on('save-provider', () => this.save(true))
    },
    beforeDestroy() {
        this.$global.$off('trigger-save')
        this.$global.$off('save-provider')
    }
}
</script>
